
  import { Component, Vue } from 'vue-property-decorator';
  import { mapGetters } from 'vuex';

  import { ICookieModel } from '@/models/cookie.model';
  import { IUserModel } from '@/models/account.model';

  import accountService from '@/services/account.service';
  import cookieService from '@/services/cookie.service';

  @Component({
    computed: {
      ...mapGetters([
        'user',
        'isLoading',
        'isLinkingCallbackLoading'
      ])
    }
  })
  export default class CookiesControl extends Vue {
    data() {
      return {
        cookiesList: [] as Array<ICookieModel>,
        hasCustomCookiesManagement: false,
        showCookiesButton: false,
        showCookiesControlModal: false,
        showCookiesSettings: false,
        unwatch: null,
        cookiesPolicy: "",
      }
    }

    created() {
      this.$data.showCookiesSettings = this.$data.RCEnvironment.VUE_APP_HAS_CUSTOM_COOKIES_MANAGEMENT == false;
      this.$data.showCookiesButton = this.$data.RCEnvironment.VUE_APP_HAS_CUSTOM_COOKIES_MANAGEMENT == true;
      this.$data.hasCustomCookiesManagement = this.$data.RCEnvironment.VUE_APP_HAS_CUSTOM_COOKIES_MANAGEMENT == true;

      this.$data.cookiesPolicy = this.$data.RCEnvironment.VUE_APP_COOKIES_POLICY_LINK;

      if (this.$data.RCEnvironment.VUE_APP_HAS_CUSTOM_COOKIES_MANAGEMENT == false) {
        this.setCookiesSettings();

        this.$data.unwatch = this.$store.watch(() => this.$store.getters.user, user => {
          this.loadCookies();
          this.setCookiesSettings();
        })

        this.loadCookies();
      }
    }

    setCookiesSettings() {
      const consentCookie = this.$cookies.get("consent_cookies");
      let showCookiesSettings = consentCookie != null && consentCookie == "1" ? false : true;

      const user: IUserModel = this.$store.getters.user;
      if (user != null && user.Id != null) {
        if (!showCookiesSettings && !user.IsCookiePopupSeen) {
          cookieService.seeCookiePopup(this)
            .then(() => {
              cookieService.setConsentCookies(this);
              this.$set(this.$data, "showCookiesButton", false);
              this.$set(this.$data, "showCookiesSettings", false);
            });
        } else {
          showCookiesSettings = !user.IsCookiePopupSeen;

          if (user.IsCookiePopupSeen) {
            cookieService.setConsentCookies(this);
          }

          this.$set(this.$data, "showCookiesButton", false);
          this.$set(this.$data, "showCookiesSettings", showCookiesSettings);
        }
      } else {
        this.$set(this.$data, "showCookiesButton", !showCookiesSettings);
        this.$set(this.$data, "showCookiesSettings", showCookiesSettings);
      }
    }

    destroyed() {
      this.$data.unwatch();
    }

    loadCookies() {
      cookieService.getCookiesList(this)
        .then(cookies => {
          const consentAnalytics = this.$cookies.get("consent_analytics");
          const isConsentAnalyticsAccepted = consentAnalytics != null && consentAnalytics == "1";
          const analyticalCookie = cookies.find(cookie => cookie.Name == "Analytical cookies");
          if (isConsentAnalyticsAccepted && analyticalCookie != null) {
            analyticalCookie.IsAccepted = true;
          }

          const consentMarketing = this.$cookies.get("consent_marketing");
          const isConsentMarketingAccepted = consentMarketing != null && consentMarketing == "1";
          const marketingCookie = cookies.find(cookie => cookie.Name == "Marketing cookies");
          if (isConsentMarketingAccepted && marketingCookie != null) {
            marketingCookie.IsAccepted = true;
          }

          this.$set(this.$data, "cookiesList", cookies);
          this.$store.dispatch("updateCookies", cookies);
        })
        .catch(error => console.log("error", error));
    }

    goToCookiesSettings() {
      if (this.$store.getters.user != null && this.$store.getters.user.Id != null) {
        this.$router.push({ name: "Cookies" });
      }
      else {
        this.$set(this.$data, "showCookiesControlModal", true);
      }
    }

    acceptAllCookies() {
      const user = this.$store.getters.user;
      if (user != null && user.Id != null) {

        const url: string = this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "cookie/user/" + user.Id + "/accept-all";
        accountService.post(this, url, { IsAllReject: false }, { headers: { Authorization: "Bearer " + this.$store.getters.token.Value } }).then(() => {
          this.setAllCookies();
        });
      }
      else {
        this.setAllCookies();
        this.$set(this.$data, "showCookiesButton", true);
      }
    }

    rejectAllCookies() {
      const user = this.$store.getters.user;

      if (user != null && user.Id != null) {
        const url: string = this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "cookie/user/" + user.Id + "/accept-all";
        accountService.post(this, url, { IsAllReject: true }, { headers: { Authorization: "Bearer " + this.$store.getters.token.Value } });
      }
      else {
        this.$data.cookiesList.forEach(((cookie: ICookieModel) => cookie.IsAccepted = false));
        this.$set(this.$data, "showCookiesButton", true);
      }

      cookieService.setConsentCookies(this);
      this.$set(this.$data, "showCookiesSettings", false);
      this.$set(this.$data, "showCookiesControlModal", false);
    }

    setAllCookies() {
      cookieService.setConsentCookies(this);

      cookieService.enableAnalytics(this);
      cookieService.enableAnalytics(this, true);
      cookieService.triggerHistoryEvent(this);

      this.$set(this.$data, "showCookiesSettings", false);
      this.$data.cookiesList.forEach(((cookie: ICookieModel) => cookie.IsAccepted = true));
    }

    setCookie(cookie: ICookieModel) {
      if (!cookie.IsActive) {
        return;
      }

      cookie.IsAccepted = !cookie.IsAccepted;
    }

    confirmCookies() {
      this.$data.cookiesList.forEach((cookie: ICookieModel) => {
        if (cookie.Name == "Analytical cookies") {
          cookie.IsAccepted ? cookieService.enableAnalytics(this) : cookieService.disableAnalytics(this);
        }
        else if (cookie.Name == "Marketing cookies") {
          cookie.IsAccepted ? cookieService.enableAnalytics(this, true) : cookieService.disableAnalytics(this, true);
        }

        if (cookie.IsAccepted) {
          cookieService.triggerHistoryEvent(this);
        }
      });

      cookieService.setConsentCookies(this);
      this.$set(this.$data, "showCookiesSettings", false);
      this.$set(this.$data, "showCookiesControlModal", false);
    }

    openCookiesSettings() {
      this.$set(this.$data, "showCookiesControlModal", !this.$data.showCookiesControlModal);
      this.$set(this.$data, "showCookiesSettings", this.$data.showCookiesControlModal);
      this.$set(this.$data, "showCookiesButton", false);
    }
  }
